module.exports = __webpack_public_path__ + "static/img/tip.de666c62.gif";